module.exports = __webpack_public_path__ + "static/media/vital-off.ad569dc4.svg";